<template>
<section class="signature-container">
<div class="signature-canvas">
  <h3>נא לחתום כאן:</h3>
 <VueSignaturePad :customStyle="canvasStyle"  ref="signaturePad"/>
</div>
  <div class="btns-section">
    <div class="end-and-clear">
    <button @click="goBack" class="btn btn-primary">חזור אחורה</button>
    <button @click="clearSignature()" class="btn btn-warning">אפס חתימה</button>
    </div>
    <button @click="saveSignature" class="btn btn-success">סיום</button>
  </div>
</section>
</template>

<script>
export default {
  name: "signature",
  data(){
    return{
      signatureBase:null
    }
  },
  created() {
  },
  methods:{
    goBack(){
      this.$emit("showAgreement")
    },
  clearSignature(){
    this.$refs.signaturePad.clearSignature();
  },
    saveSignature(){
      const signatureObj = this.$refs.signaturePad.saveSignature();
      if(signatureObj.isEmpty) return;
      this.$emit("createPdf",signatureObj.data)
    },
  },
  computed:{
    canvasStyle(){
      return {
        border:'1px solid lightgray',
        borderRadius:'10px',
        width:'80%',
        margin:'0 auto',
        height:'300px'
      }
    },
  }
};
</script>

<style scoped>
.signature-container{
  background-color: red;
  direction: rtl;
  font-family: Tahoma;
  margin: 0 auto;
  margin-top: 50px;
  text-align: center;
  width: 80%;
  box-shadow: 0px 1px 4px #00000022;;
  background-color: #fafafa;
  padding: 15px 30px;
}
.btns-section{
  display: flex;
  justify-content: space-between;
}
.end-and-clear{
  width: 210px;
  display: flex;
  justify-content: space-between;
}
.signature-canvas{
  margin-bottom: 20px;
}

@media (max-width: 500px){
.btns-section,.end-and-clear{
  flex-direction: column;
  width: 100%;
}
  button{
    margin-bottom: 5px;
  }
}
</style>